import { useCustomQuery } from "../custom-query";
import { useCustomMutation } from "../custom-mutation";
import { get, post, put, del } from "../request-helpers";
import {
  GetDiscountCodes,
  PostDiscountCode,
  GetDiscountCode,
  PutDiscountCode,
  DeleteDiscountCode,
} from "@/server-types";

export const useGetDiscountCodes = (
  query: GetDiscountCodes["query"],
  enabled?: boolean,
) => {
  return useCustomQuery({
    queryKey: ["useGetDiscountCodes", query],
    queryFn: () => get<GetDiscountCodes>("/discount-code", query),
    enabled: enabled ?? true,
  });
};

export const usePostDiscountCode = () => {
  return useCustomMutation({
    mutationFn: (props: { body: PostDiscountCode["body"] }) =>
      post<PostDiscountCode>("/discount-code", props.body),
  });
};

export const useGetDiscountCode = (
  params: GetDiscountCode["params"],
  enabled?: boolean,
) => {
  return useCustomQuery({
    queryKey: ["useGetDiscountCode", params],
    queryFn: () =>
      get<GetDiscountCode>(`/discount-code/${params.discountCodeId}`),
    enabled: enabled ?? true,
  });
};

export const usePutDiscountCode = () => {
  return useCustomMutation({
    mutationFn: (props: {
      params: PutDiscountCode["params"];
      body: PutDiscountCode["body"];
    }) =>
      put<PutDiscountCode>(
        `/discount-code/${props.params.discountCodeId}`,
        props.body,
      ),
  });
};

export const useDeleteDiscountCode = () => {
  return useCustomMutation({
    mutationFn: (props: { params: DeleteDiscountCode["params"] }) =>
      del<DeleteDiscountCode>(`/discount-code/${props.params.discountCodeId}`),
  });
};
